import { useState } from "react";
import useGet from "../read/useGet";

const useGetChatList = (initialLimit = 10, initialPageNo = 1, screen = "ALL") => {
  const [limit, setLimit] = useState(initialLimit);
  const [pageNo, setPageNo] = useState(initialPageNo);
  
  const { list, paramsObject, setGetListParams } = useGet({
    url: "chat/my-chat-list",
    initialData: {
      limit,
      pageNo,
      screen, 
    },
    isChat: true,
  });

  const loadMoreData = () => {
    if (list.data?.pagination.hasMorePages) {
      setPageNo(pageNo + 1);
      setGetListParams({
        ...paramsObject,
        pageNo: pageNo + 1,
      });
    }
  };

  return {
    chatList: list.data?.data || [],
    loading: list.isLoading,
    error: list.error,
    pagination: list.data?.pagination,
    loadMoreData,
    refetch: list.refetch
  };
};

export default useGetChatList;
